import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class NotificationValidator {
  static atLeastOneNotificationRequired(): ValidatorFn {
    return (formGroup: AbstractControl): ValidationErrors | null => {
      const isPushNotification = formGroup.get('isPushNotification')?.value;
      const isSMS = formGroup.get('isSMS')?.value;
      const isWhatsApp = formGroup.get('isWhatsApp')?.value;
      const isEmail = formGroup.get('isEmail')?.value;

      return isPushNotification || isSMS || isWhatsApp || isEmail
        ? null
        : { atLeastOneRequired: true }; // Return error if none are selected
    };
  }
}
